import { documentHasElements } from "modules/dom";
import "./tab-container-block.scss";

documentHasElements(".js-tab-container-block", (tabContainerBlocks) => {
    tabContainerBlocks.forEach((tabContainerBlock) => {
        const blocks = tabContainerBlock.querySelectorAll(".tab-blocks > div");
        const tabs = tabContainerBlock.querySelector(".tab-list");
        const images = tabContainerBlock.querySelector(".tab-images");

        // Create list items for each block
        blocks.forEach((block, index) => {
            block.setAttribute("data-item", index.toString());

            const listItem = document.createElement("li");
            const blockId = block.getAttribute("id");
            const image = block.querySelector(".col.image")

            listItem.setAttribute("data-item", index.toString());
            
            if (blockId !== null) {
                listItem.innerHTML = blockId.toString();
            }

            if (listItem && tabs) {
                tabs.appendChild(listItem);
            }

            if (images && image) {
                image.setAttribute("image-item", index.toString());
                const clone = image.cloneNode(true)
                image.removeAttribute("image-item");

                images.appendChild(clone);
            }
        });

        const tabButtons = tabContainerBlock.querySelectorAll(".tab-list li");

        // Initialize first tab as active
        tabButtons[0]?.classList.add('active');
        blocks[0]?.classList.add('active');
        images?.children[0]?.classList.add('active');

        // Handle tab click events
        tabButtons.forEach((tab) => {
            tab.addEventListener("click", () => {
                const isActive = tab.classList.contains("active");
                const tabId = tab.getAttribute("data-item");
                const tabContent = tabContainerBlock.querySelectorAll(`div[data-item="${tabId}"]`);
                const tabImage = tabContainerBlock.querySelectorAll(`div[image-item="${tabId}"]`);

                if (isActive) {
                    return
                }

                // Close all tabs
                tabButtons.forEach((otherTab) => otherTab.classList.remove("active"));
                blocks.forEach((block) => block.classList.remove('active'));
                images?.querySelector(".image.active")?.classList.remove('active');

                // Open clicked tab if not already active
                if (!isActive) {
                    tab.classList.add("active");
                    tabContent[0].classList.add('active');
                    tabImage[0].classList.add('active');

                    if (document.documentElement.clientWidth < 800) {     
                        const tabWrapper = tab.parentElement?.parentElement;

                        if (tabWrapper != null) {
                            tabWrapper.scrollTo({
                                top: 0,
                                left: (tab as HTMLElement).offsetLeft - 15,
                                behavior: 'smooth'
                            });
                        }
                    }
                }
            });
        });
    });
});